import React from "react";
import {useTranslation} from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import {SecondaryButton} from "./SecondaryButton";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";
import {useTheme} from "@mui/material";

export function OutlinedAddButton(props: {
  onClick: () => void,
  title?: string,
  sx?: SxProps<Theme>,
  size?: 'small' | 'medium' | 'large',
}) {
  const {t} = useTranslation();
  const theme = useTheme();
  return (
    <SecondaryButton size={props.size}
                     sx={{
                       color: 'text.secondary',
                       backgroundColor: 'background.light',
                       borderColor: 'secondary.main',
                       minWidth: 150,
                       marginLeft: theme.spacing(1),
                     }}
                     onClick={props.onClick}
                     title={props.title || t('buttons.create')}
                     startIcon={<AddIcon/>}
    />
  )
}
